import {
    getCateringFormatBySlug,
    GetCateringFormatBySlugApiResponseSchema,
} from './get-catering-cormat-by-uid';

export {
    GetCateringFormatBySlugApiResponseSchema,
};

export const CateringFormatPageActions = {
    getCateringFormatBySlug,
};
